import listActions from 'src/modules/asignadorFuncion/list/asignadorFuncionListActions';
import AsignadorFuncionService from 'src/modules/asignadorFuncion/asignadorFuncionService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'ASIGNADORFUNCION_DESTROY';

const asignadorFuncionDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: asignadorFuncionDestroyActions.DESTROY_STARTED,
      });

      await AsignadorFuncionService.destroyAll([id]);

      dispatch({
        type: asignadorFuncionDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.asignadorFuncion.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/asignador-funcion');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: asignadorFuncionDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: asignadorFuncionDestroyActions.DESTROY_ALL_STARTED,
      });

      await AsignadorFuncionService.destroyAll(ids);

      dispatch({
        type: asignadorFuncionDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.asignadorFuncion.destroyAll.success'),
      );

      getHistory().push('/asignador-funcion');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: asignadorFuncionDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default asignadorFuncionDestroyActions;
